import { createRootRoute, Outlet } from "@tanstack/react-router";
import type { JSX } from "react";

const RootLayout = (): JSX.Element => (
  <>
    <Outlet />
    {/* <TanStackRouterDevtools /> */}
  </>
);

export const Route = createRootRoute({ component: RootLayout });
